import { create } from 'zustand';

export const useCartStore = create((set) => ({
  isCartOpen: false,
  openCart: () => set({ isCartOpen: true }),
  closeCart: () => set({ isCartOpen: false }),

  // 'plans' | 'contact'
  step: 'plans',
  setStep: (step) => set({ step }),

  // Selected Commerce product variation
  selectedVariation: null,
  setSelectedVariation: (variation) => set({ selectedVariation: variation }),

  // Commerce order UUID — set after POST /jsonapi/cart/add
  orderUuid: null,
  setOrderUuid: (uuid) => set({ orderUuid: uuid }),

  // JSON:API resource type string for the order (e.g. "order--impact-subscription-order")
  // Needed for PATCH /jsonapi/checkout/{uuid} body — sourced from cart/add response
  orderType: null,
  setOrderType: (type) => set({ orderType: type }),

  reset: () => set({ step: 'plans', selectedVariation: null, orderUuid: null, orderType: null }),
}));
